export const REFRESH_SEARCH_FROM_HISTORY = 'refresh-search-from-history';
const refreshSearchFromHistory = () => ({
  type: REFRESH_SEARCH_FROM_HISTORY,
  payload: {},
});
export default refreshSearchFromHistory;
